class PositionSourcesCollection extends App.Collections.BaseCollection {
  url = null;
  model = App.Models.PositionSource;

  add = (data) => {
    if (!data) return;
    const UNKNOWN_SOURCE = 'UNKNOWN_SOURCE';
    const grouped = new Map();
    data = Array.isArray(data) ? data : [data];
    data.forEach((item) => {
      const source =
        item['positionSource']?.source?.replace(/\s+/g, '_').toUpperCase() ||
        UNKNOWN_SOURCE;
      if (!grouped.has(source)) {
        grouped.set(source, {
          positionSource:
            source !== UNKNOWN_SOURCE
              ? item['positionSource']
              : { source: UNKNOWN_SOURCE },
          coordinates: []
        });
      }
      grouped.get(source).coordinates.push(item);
    });
    grouped.keys()?.forEach((source) => {
      this.id = source;
      this.addModel(new this.model(grouped.get(source)));
    });
  };

  sortBySourceType = () => {
    this.models.sort((sourcePositionA) => {       
      if (sourcePositionA.get('sourceType') === 'TELEMATICS') {
        return 1;
      }
      if (sourcePositionA.get('sourceType') === 'MOBILE') {
        return 2;
      }
      return 99;
    });
  };

  mapToTelematics = () => {
    const pathColors = ['#FF41A6', '#FF7D00'];
    return this.models.map((model, index) => ({
      ...model.get('positionSource'),
      color: pathColors[index % pathColors.length],
      telematicsList: model.get('coordinates').getTelematicsList(),
    }));
  }
}

App.Collections.PositionSources = PositionSourcesCollection;
